import { EditorRoot } from '../../editor/EditorRoot';
import { WelcomeModal } from '../WelcomeModal';
import { ToolNavbar } from './ToolNavbar';
import { WallLengthModal } from '../WallLengthModal';


export function PageLayout() {

    // if (isMobile) {
    //     return <>
    //         <Modal
    //             opened={true}
    //             withCloseButton={false}
    //             onClose={() => (false)}
    //         >
    //             <Center>
    //                 <Image src={ArcadaLogo}/>
    //             </Center>
    //             We're sorry, but Arcada is currently only intended for desktops.
    //         </Modal>
    //     </>
    // }

    return (<>

        <WelcomeModal />
        <WallLengthModal />
        <ToolNavbar></ToolNavbar>

        <EditorRoot />
    </>
    );
}
